import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo } from "preact/hooks"
import { productImagePlaceholder, getSrcset, currency } from "../helpers"
import { isUS } from "../config"

export default function Product({ product, isCategory }) {
    const { format } = useCurrencyFormatting()
    const handle = useMemo(() => product.url.split('/products/')[1],[])
    const url = useMemo(() => `${isCategory ? location.pathname : ''}/products/${handle}`, [ isCategory, handle ])
    const hasDiscount = useMemo(() => product.listPrice && product.listPrice > product.price, []);
    const skuCode = useMemo(() => product.skus?.[0]?.customFields?.find(f => f.key === "skucode")?.value,[])

    return (
        <SerpElement
            as="div"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="ns-product ns-markets product-card space-y-4"
            data-handle={handle}
        >
            <div class="product-card__image">
                <a class="product-card__link" href={url}>
                    <img
                        src={product.imageUrl.replace('.jpg', '_600x.png').replace('.png', '_600x.png').replace('.webp', '_600x.png')}
                        alt="A close-up of a champagne blonde hair extension featuring wavy hair, showcasing its rich texture and vibrant color."
                        srcset={getSrcset(product.imageUrl, [300, 350, 400, 450, 500, 550, 600])}
                        width="600"
                        height="750"
                        loading="lazy"
                        sizes="(min-width: 767px) 25vw, (min-width: 1440px) 300px, 50vw"
                        class="product-card__image--primary"
                    />
                    {product.alternateImageUrls?.length > 0 && product.alternateImageUrls[0] !== "" && (
                        <img
                            src={product.alternateImageUrls[0].replace('.jpg', '_600x.png').replace('.png', '_600x.png').replace('.webp', '_600x.png')}
                            alt="A close-up of a champagne blonde hair extension featuring wavy hair, showcasing its rich texture and vibrant color."
                            srcset={getSrcset(product.alternateImageUrls[0], [300, 350, 400, 450, 500, 550, 600])}
                            width="600"
                            height="750"
                            loading="lazy"
                            sizes="(min-width: 767px) 25vw, (min-width: 1440px) 300px, 50vw"
                            class="product-card__image--secondary"
                        />
                    )}
                </a>
                <div class="product-card__tag-container"></div>
                <div class="product-card__quick-view">
                    <button 
                        class="button button--light" 
                        type="button" 
                        data-quick-view-trigger="" 
                        data-quick-view-product-handle={handle}
                    >
                        <span class="text-nowrap">Quick View</span>
                    </button>
                </div>
            </div>
            <div class="product-card__content space-y-1">
                {!isUS && (
                    <div 
                        class="ruk_rating_snippet" 
                        data-sku={skuCode}
                    />
                )}
                <a class="product-card__link" href={url}>
                    <h2 class="h8 text-center">{product.name}</h2>
                </a>
                <div class="text-center">
                    <div class={`price ${hasDiscount ? 'price--on-sale' : ''}`}>
                        <div class="price__container">
                            <span class="sr-only">Sale price</span>
                            <span class="price-item price-item--sale" data-product-regular-price="">
                                {format(product.price)}
                            </span>
                            {hasDiscount && (
                                <>
                                    <span class="sr-only ">Regular price</span>
                                    <span>
                                        <s class="price-item price-item--regular" data-product-compare-price="">
                                            {format(product.listPrice)}
                                        </s>
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SerpElement>
    )
}
